import React, { useState, useEffect, useContext, useRef } from 'react';
import { zendoStorage } from '../../../hybrid/wrappers';
import Single from '../../single/Single/Single';
import UserContext, { StoreContext } from '../../../common/utils/getContext';
import { getCartData, useRouteAnimation } from '../../../common/utils/utils';
import uikit from '../../../project/uikit/uikit.module.scss';
import PropTypes from 'prop-types';
// import { getWishList } from '../../../common/utils/memo';
import classNames from 'classnames';
import css from './store.module.scss';
import { getRoute } from '../../../common/utils/router';
import T from '../../../common/components/T';
import CantBuyModal from '../components/CantBuyModal/CantBuyModal';
import Skeleton from '../../../widgets/plug/Skeleton/Skeleton';
import { breadcrumbsSkeleton } from '../../../widgets/plug/Skeleton/components/patterns';
const project = require('../../../scripts/configs/project.json');
import StoreBreadcrumbs from '../../../widgets/breadcrumbs/SingleBreadCrumbs';
import Image from 'next/image';

const Store = ({
    children,
    categories,
    breadcrumbs = [],
    showBreadcrumbs = false,
    title,
    translates,
    seoData,
    alias,
    canonical,
    disabledTransition,
    compStyles,
    OverFooter,
    officeBg = false,
    hideBeforeHeader = false
}) => {
    const { localization, storageLoaded, userToken, lang, routerLoader, profile } = useContext(UserContext);

    const [isLoading, setIsLoading] = useState(true);
    const [cartData, setCartData] = useState({ items: [] });
    const [reloadCart, setReloadCart] = useState(false);
    const [cart, setCart] = useState(false);
    const [wishlist, setWishlist] = useState({});
    const beforeHeaderRef = useRef();
    const [cantBuyModal, setCantBuyModal] = useState(false);
    const [deliveryCurrency, setDeliveryCurrency] = useState(false);

    useEffect(() => {
        if ((userToken && !profile) || !storageLoaded) {
            return;
        } else {
            (async () => {
                if (deliveryCurrency || (!!localization && Object.keys(localization).length > 0)) {
                    const cartId = zendoStorage.get('cart_id');
                    const cartDataRes = await getCartData(
                        cartId,
                        userToken,
                        lang,
                        false,
                        userToken ? profile?.currency?.code : deliveryCurrency || localization.currency
                    );
                    if (cartDataRes?.data) {
                        if (!cartDataRes?.data?.items?.length) {
                            if (cartId || cartDataRes?.data?.id) {
                                const storageData = await getCartData(
                                    cartId || cartDataRes?.data?.id,
                                    userToken,
                                    lang,
                                    false,
                                    userToken ? profile?.currency?.code : deliveryCurrency || localization.currency
                                );
                                if (storageData?.data) {
                                    setCartData(storageData?.data);
                                } else {
                                    zendoStorage.remove('cart_id');
                                }
                                setIsLoading(false);
                            }
                        } else {
                            setCartData(cartDataRes?.data);
                            setIsLoading(false);
                        }
                    } else {
                        setIsLoading(false);
                    }
                }
            })().then(() => {
                // setIsLoading(false);
            });
        }
    }, [deliveryCurrency, localization.currency, storageLoaded, userToken, lang, reloadCart, profile]);

    const disabledAllTransition =
        routerLoader &&
        project?.rootSeoUrl &&
        ((getRoute(routerLoader?.from) === project?.rootSeoUrl && getRoute(routerLoader?.to) === '/') ||
            (getRoute(routerLoader?.from) === '/' && getRoute(routerLoader?.to) === project?.rootSeoUrl));

    const disabledParentTransition =
        disabledAllTransition || (routerLoader && routerLoader?.from?.includes(`/store`) && routerLoader?.to?.includes(`/store`));

    const routerLoaderClass = useRouteAnimation(disabledTransition || disabledAllTransition);

    return (
        <div
            style={{
                minHeight: '100%'
            }}
            className={classNames(uikit.flexColumn, css.containerStore, compStyles?.containerStore)}
        >
            {!officeBg || hideBeforeHeader ? null : (
                <div ref={beforeHeaderRef} className={css.storeBeforeHeader}>
                    <p className={css.storeBeforeHeaderText}>
                        <T
                            textName='info-before-header'
                            defaultStr='При покупке товара на 600 PV Вы можете участвовать в Колесе Фортуны'
                        />
                    </p>
                </div>
            )}
            {officeBg ? (
                <div className={css.officeBgVideoWrapper}>
                    <div className={css.officeBgVideoRectangle}></div>
                    <video playsInline disablePictureInPicture autoPlay muted className={css.officeBgVideo} controls={false} loop>
                        <source src='../../src/video/office/bg_video.mp4' type='video/mp4' />
                        <source src='../../../src/video/office/bg_video.mp4' type='video/mp4' />
                    </video>
                </div>
            ) : (
                <div className={css.storeTopBG}>
                    <Image fill src='/src/img/store/StoreTopBG.png' alt='Store image' />
                    <div className={classNames('jumbo', css.storeTopBGEffect)}></div>
                </div>
            )}
            {/* <Img src='/src/img/store/StoreTopBG.png' alt='Top image' className={css.containerTopImage} /> */}
            <StoreContext.Provider
                value={{
                    cartData,
                    setCartData,
                    cart,
                    setCart,
                    wishlist,
                    setWishlist,
                    isLoading,
                    setCantBuyModal,
                    cantBuyModal,
                    categories,
                    setReloadCart,
                    setDeliveryCurrency,
                    deliveryCurrency
                }}
            >
                <Single
                    disabledTransition={disabledParentTransition}
                    translates={translates}
                    seoData={seoData}
                    alias={alias}
                    title={title}
                    canonical={canonical}
                    beforeHeaderRef={beforeHeaderRef}
                    compStyles={compStyles}
                    OverFooter={OverFooter}
                    officeBg={officeBg}
                    isStoreLayout={true}
                >
                    {/* <StoreHeader
                        loadMoreCategories={loadMoreCategories}
                        categories={categories}
                        openCart={openCart}
                        setOpenCart={setOpenCart}
                        qSearch={qSearch}
                    /> */}
                    {showBreadcrumbs ? (
                        <Skeleton
                            wrapperStyles={classNames(
                                css.blockXl,
                                css.breadcrumb,
                                uikit.flexColumn,
                                uikit.alignItemsUnset,
                                officeBg && css.posRel
                            )}
                            itemsShiners={true}
                            pattern={breadcrumbsSkeleton}
                            Component={StoreBreadcrumbs}
                            componentProps={{ compStyles: css, breadcrumbs }}
                        />
                    ) : null}
                    <div className={routerLoaderClass}>{children}</div>
                    {cantBuyModal ? <CantBuyModal closeHandler={() => setCantBuyModal(false)} /> : null}
                </Single>
            </StoreContext.Provider>
        </div>
    );
};
Store.propTypes = {
    styles: PropTypes.object,
    categories: PropTypes.array,
    breadcrumbs: PropTypes.array,
    title: PropTypes.string,
    qSearch: PropTypes.string,
    translates: PropTypes.object
};
export default Store;
